import React, { useState } from 'react'
import {
  Container,
  Box,
  Text,
  Image,
  SimpleGrid,
  Input,
  Textarea,
  Button,
} from '@chakra-ui/react'
import styled from 'styled-components'
import ContactUsModel from './ContactUsModel/index'
import ContactImage from '../../../../assets/pngs/contactImage.jpg'

const ContactUsWrapper = styled.section`
  display: inline-block;
  width: 100%;
  padding: 100px 0px 100px;
  background: #83b53c;
`

const ContactUs = ({ title, subtitle, description, file, actions = [] }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ContactUsWrapper id="contact-us">
        <Container
          maxW={[
            'container.sm',
            'container.md',
            'container.lg',
            'container.xl',
          ]}
        >
          <SimpleGrid columns={[1, 1, 2, 2]} spacing={[30, , , 125]}>
            <Box
              display="flex"
              width="100%"
              position="relative"
              paddingLeft={['0px', , , '45px']}
            >
              <Image
                src={file}
                alt="contactImage_img"
                width="100%"
                objectFit="cover"
                height={['300px', '300px', '100%', '320px']}
                border="5px solid #FFFFFF"
                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                zIndex="1"
              />
              <Box
                position="absolute"
                top="-39px"
                left="0px"
                width="342px"
                height="418px"
                background="#FFFFFF"
                display={['none', 'none', 'none', 'block']}
              />
            </Box>
            <Box display="flex" flexFlow="column" justifyContent="space-around">
              <Text
                as={'h3'}
                fontSize={['28px', '', '', '50px']}
                lineHeight={['36px', '', '', '58px']}
                fontWeight="bold"
                color="#FFFFFF"
                marginBottom="12px"
              >
                {title}
              </Text>
              <Text
                fontSize={['16px', '', '', '18px']}
                color="#FFFFFF"
                marginBottom="18px"
              >
                {description}
              </Text>
              <SimpleGrid
                columns={[1, 1, 2, 2]}
                spacing={[30, , , '30px 18px']}
                marginBottom="18px"
              >
                <Input
                  placeholder="First name"
                  border="1px solid"
                  borderColor="#1E3240"
                  background="#FFFFFF"
                  borderRadius="0px"
                  color="#BDBDBD"
                  height="50px"
                  _hover={{
                    borderColor: '#1E3240',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
                <Input
                  placeholder="Last name"
                  border="1px solid"
                  borderColor="#1E3240"
                  background="#FFFFFF"
                  borderRadius="0px"
                  color="#BDBDBD"
                  height="50px"
                  _hover={{
                    borderColor: '#1E3240',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
              </SimpleGrid>
              <SimpleGrid
                columns={[1, 1, 2, 2]}
                spacing={[30, , , '30px 18px']}
                marginBottom="18px"
              >
                <Input
                  placeholder="Email address"
                  border="1px solid"
                  borderColor="#1E3240"
                  background="#FFFFFF"
                  borderRadius="0px"
                  color="#BDBDBD"
                  height="50px"
                  _hover={{
                    borderColor: '#1E3240',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
                <Input
                  placeholder="Phone number"
                  border="1px solid"
                  borderColor="#1E3240"
                  background="#FFFFFF"
                  borderRadius="0px"
                  color="#BDBDBD"
                  height="50px"
                  _hover={{
                    borderColor: '#1E3240',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
              </SimpleGrid>
              <SimpleGrid columns={[1, , , 1]} marginBottom="40px">
                <Textarea
                  placeholder="Description"
                  border="1px solid"
                  borderColor="#1E3240"
                  background="#FFFFFF"
                  borderRadius="0px"
                  color="#BDBDBD"
                  height="50px"
                  _hover={{
                    borderColor: '#1E3240',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                />
              </SimpleGrid>
              <Box display="flex" alignItems="center">
                {(actions || []).map((item) => (
                  <Button
                    variant="solid"
                    fontSize="14px"
                    color="#FFFFFF"
                    background="#1E3240"
                    outline="none !important"
                    boxShadow="none"
                    borderRadius="0px"
                    height="53px"
                    border="none"
                    marginRight="19px"
                    _hover={{ background: '#1E3240' }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => setIsOpen(true)}
                  >
                    {item.text}
                  </Button>
                ))}
                <Text as={'span'} fontSize="12px" color="#FFFFFF" opacity="0.6">
                  {subtitle}
                </Text>
              </Box>
            </Box>
          </SimpleGrid>
        </Container>
      </ContactUsWrapper>
      <ContactUsModel onClick={(value) => setIsOpen(value)} isOpen={isOpen} />
    </>
  )
}

export default ContactUs
